// NOTE: included relationships themselves are deprecated,
// but we have a common pattern for them that searches by
// id and ignores the type so this method aims to fix that
// for the meantime by respecting both

export default function findIncludedRelationship(includes, relationshipData) {
  const type = relationshipData.type
  const id = relationshipData.id
  return includes.find((include) => {
    return include.id === id && include.type === type
  })
}
